import { render, staticRenderFns } from "./allocation-info-card.component.vue?vue&type=template&id=2dfdc4d4&scoped=true"
import script from "./allocation-info-card.component.vue?vue&type=script&lang=js"
export * from "./allocation-info-card.component.vue?vue&type=script&lang=js"
import style0 from "./allocation-info-card.component.vue?vue&type=style&index=0&id=2dfdc4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdc4d4",
  null
  
)

export default component.exports